import { PerfumeRepositoryFirebase } from "./PerfumeRepositoryFirebase";
import { AuthenticationRepository } from "./AuthenticationRepository";
import { IngredientLotsRepository } from "./IngredientLotsRepository";
import { PerfumeEmailRepository } from "./PerfumeEmailRepository";
import type { FirebaseWrapper } from "@/infra/FirebaseWrapper";

export class Repositories {
  perfumeRepository: PerfumeRepositoryFirebase;
  authenticationRepository: AuthenticationRepository;
  ingredientLotsRepository: IngredientLotsRepository;
  perfumeEmailRepository: PerfumeEmailRepository;

  constructor(firebaseWrapper: FirebaseWrapper) {
    this.perfumeRepository = new PerfumeRepositoryFirebase(firebaseWrapper.firestore);
    this.authenticationRepository = new AuthenticationRepository(firebaseWrapper);
    this.ingredientLotsRepository = new IngredientLotsRepository(firebaseWrapper.firestore);
    this.perfumeEmailRepository = new PerfumeEmailRepository(firebaseWrapper.functions);
  }
}
